export const GET_USER_LIST = 'GET_USER_LIST'
export const GET_USER_LIST_SUCCESS = 'GET_USER_LIST_SUCCESS'
export const GET_USER_LIST_FAIL = 'GET_USER_LIST_FAIL'

export const GET_EXCEL_FILE = 'GET_EXCEL_FILE'
export const GET_EXCEL_FILE_SUCCESS = 'GET_EXCEL_FILE_SUCCESS'
export const GET_EXCEL_FILE_FAIL = 'GET_EXCEL_FILE_FAIL'

export const GET_USER_CARD = 'GET_USER_CARD'
export const GET_USER_CARD_SUCCESS = 'GET_USER_CARD_SUCCESS'
export const GET_USER_CARD_FAIL = 'GET_USER_CARD_FAIL'

export const GET_USER_VIEW = 'GET_USER_VIEW'
export const GET_USER_VIEW_SUCCESS = 'GET_USER_VIEW_SUCCESS'
export const GET_USER_VIEW_FAIL = 'GET_USER_VIEW_FAIL'

export const GET_USER_HISTORY = 'GET_USER_HISTORY'
export const GET_USER_HISTORY_SUCCESS = 'GET_USER_HISTORY_SUCCESS'
export const GET_USER_HISTORY_FAIL = 'GET_USER_HISTORY_FAIL'

export const GET_COUNTRY_LIST = 'GET_COUNTRY_LIST'
export const GET_COUNTRY_LIST_SUCCESS = 'GET_COUNTRY_LIST_SUCCESS'
export const GET_COUNTRY_LIST_FAIL = 'GET_COUNTRY_LIST_FAIL'

export const GET_USERPROFILE_EXCEL = 'GET_USERPROFILE_EXCEL'
export const GET_USERPROFILE_EXCEL_SUCCESS = 'GET_USERPROFILE_EXCEL_SUCCESS'
export const GET_USERPROFILE_EXCEL_FAIL = 'GET_USERPROFILE_EXCEL_FAIL'

export const GET_REPORT = 'GET_REPORT'
export const GET_REPORT_SUCCESS = 'GET_REPORT_SUCCESS'
export const GET_REPORT_FAIL = 'GET_REPORT_FAIL'

export const DEACTIVATED_USER_VIEW = 'DEACTIVATED_USER_VIEW'
export const DEACTIVATED = 'DEACTIVATED'

export const GET_CALENDAR = 'GET_CALENDAR'
export const GET_CALENDAR_SUCCESS = 'GET_CALENDAR_SUCCESS'
export const GET_CALENDAR_FAIL = 'GET_CALENDAR_FAIL'

export const GET_DAILY = 'GET_DAILY'
export const GET_DAILY_SUCCESS = 'GET_DAILY_SUCCESS'
export const GET_DAILY_FAIL = 'GET_DAILY_FAIL'
